// extracted by mini-css-extract-plugin
export var columnList = "_ij-0";